/* eslint global-require: 0, no-underscore-dangle: 0 */
import * as check from './vendor/lite-browsercheck';

require('./vendor/superFix');

// IE check
let main = {
    run() {
        // Don't run anything for old IE
    }
};

function isOldIE() {
    const myNav = navigator.userAgent.toLowerCase();
    return (myNav.indexOf('msie') !== -1) ? parseInt(myNav.split('msie')[1], 10) <= 9 : false;
}

if (!isOldIE()) {
    // Riot components
    require('./components/bbc-notifications-bell.tag');
    require('./components/bbc-notifications-drawer.tag');
    require('./components/bbc-notifications-list.tag');
    require('./components/bbc-notifications-settings-view.tag');
    require('./components/bbc-notifications-onboarding-async.tag');
    require('./components/bbc-notifications-onboarding-u13.tag');
    require('./components/bbc-notifications-onboarding-u13-success.tag');
    require('./components/bbc-notifications-error-banner.tag');
    require('./components/bbc-notifications-error-view.tag');
    require('./components/bbc-notifications-idcta-html.tag');
    require('./components/bbc-notifications-signed-in-view.tag');
    require('./components/bbc-notifications-signed-out-view.tag');
    require('./components/bbc-notifications-onboarded-view.tag');
    require('./components/bbc-notifications-home-view.tag');
    require('./components/bbc-notifications.tag');

    const i18n = require('riot-i18n');
    const text = require('./i18n');
    const cookie = require('./cookie');

    i18n.dictionary(text);

    const lang = cookie.get('ckps_language');
    console.log('Language', lang);

    if (lang && text[lang]) {
        console.log('Setting language', lang);
        i18n.setLanguage(lang);
    }

    console.log('Getting language', i18n.getLanguage());

    const eventie = require('./eventie');
    const Utils = require('./utils');

    const utils = new Utils();
    const riot = require('riot');
    const userPreferencesModel = require('./models/UserPreferences');

    let onboarding;

    main = {
        name: 'mainApp',
        drawerName: 'notifications',
        errorState: false,
        notificationPanelCreated: false,

        /**
         * Sets path received from idcta and runs preparations
         * @param {Object} idcta    Reference to idcta (Checking user Authentication)
         * @param {String} basePath - path to files on CDN
         */
        run(idcta, basePath) {
            console.log('Requiring root modules');

            if (window.require) {
                window.require(['orb/nav', 'idcta/id-config'], (orb, idConfig) => {
                    console.log('Running NotificationsMain');

                    this.basePath = basePath || '';
                    __webpack_public_path__ = `${this.basePath}js/`; //eslint-disable-line

                    this.orb = orb;

                    this.setIdcta(idcta, idConfig);

                    // Mount top-level Riot tags
                    const myBBCWrapper = document.getElementById('mybbc-wrapper');
                    console.log('My BBC', myBBCWrapper);
                    const notifHold = document.getElementById('notification-link');
                    console.log('Notif hold', notifHold);

                    if (notifHold) {
                        myBBCWrapper.removeChild(notifHold);
                        const newHold = document.createElement('bbc-notifications');
                        myBBCWrapper.appendChild(newHold);
                    }

                    riot.mount('bbc-notifications', { orb, mainApp: this });

                    eventie.addEvent(document, 'ready', this._setHubResizeEvent());
                });
            }
        },

        _setHubResizeEvent() {
            console.warn('Setting resize event');
            let resizeTimeout;

            // MYNOT-374: Fixing the Hub height resize on devices and desktop
            ['resize', 'orientationchange'].forEach((eventName) => {
                eventie.addEvent(window, eventName, () => {
                    if (resizeTimeout) {
                        clearTimeout(resizeTimeout);
                    }

                    resizeTimeout = setTimeout(utils.bind(this.updateWrapperMaxHeight, this), 100);
                });
            });

            this.updateWrapperMaxHeight();
        },

        /**
         * Sets the app idcta property
         * @param {Object} idcta
         */
        setIdcta(idcta, idConfig) {
            if (typeof idcta.getInstance === 'function') {
                this.idcta = idcta.getInstance();
            } else {
                this.idcta = idcta;
            }

            this.idConfig = idConfig;

            console.log('IDCTA', this.idcta, idConfig);
        },

        /**
         * Windows Phone sniffing
         * @return {Boolean}
         */
        isWindowsPhone() {
            return (navigator.appVersion.indexOf('Win') !== -1
            && typeof window.navigator.pointerEnabled !== 'undefined'
            && navigator.userAgent.match(/.+windows.+(touch|phone).+/i) !== null);
        },

        updateWrapperMaxHeight() {
            const maximumWrapperDesktopHeight = 420;
            const coef = (check.touchevents() || this.isWindowsPhone()) ? 0.75 : 0.65;
            const orbitHeaderNavEl = document.querySelector('.orb-nav-pri-container');
            const orbitHeaderHeight = (orbitHeaderNavEl !== null) ?
                 orbitHeaderNavEl.offsetHeight : 0;
            const notificationsHeaderOffset = 44;

            const windowHeight = document.documentElement.clientHeight || window.innerHeight;

            // UX design request 65% of screen height + orb included
            // MYNOT-411: Fixed the scroll not appearing on certain devices with big heights
            let newMaxHeight = (
                (windowHeight * coef) - orbitHeaderHeight
                - notificationsHeaderOffset
            );

            // For none mobile and touch devices
            if (!check.touchevents() && !this.isWindowsPhone()) {
                newMaxHeight = Math.min(newMaxHeight, maximumWrapperDesktopHeight);
            }

            const wrapper = document.querySelector('#notifications-wrapper');
            if (wrapper) {
                wrapper.style.maxHeight = `${newMaxHeight}px`;
            }

            this.orb.updateDrawerHeight(this.drawerName);
        },

        updateDrawerHeight() {
            return this.orb.updateDrawerHeight(this.drawerName);
        },

        isUserOnBoarded() {
            const preferencesData = userPreferencesModel.get();
            console.log('Preferences model', preferencesData);
            const userPreferences = preferencesData.preferences;

            return (userPreferences !== null &&
                    typeof userPreferences.hasOnboarded !== 'undefined') ?
                    userPreferences.hasOnboarded : false;
        },

        loadOnboarding(cb) {
            console.log('Loading onboarding script');

            this.loadOnboardingStyles();

            System.import('./onboarding').then(cb);
        },

        loadOnboardingStyles() {
            console.log('Loading onboarding stylesheet');

            const fileref = document.createElement('link');
            fileref.rel = 'stylesheet';
            fileref.type = 'text/css';
            fileref.href = `${this.basePath}css/onboarding.min.css`;
            document.getElementsByTagName('head')[0].appendChild(fileref);
        },

        /**
         * Returns onboarding initialisation parameter
         * @return {Object}
         */
        getOnboardingParams(componentApp) {
            return {
                mainElSelector: '.notifications-on-boarding--js',
                app: this,
                componentApp,
                isIE: this.isIE(),
                resizeEvent: utils.bind(this._setHubResizeEvent, this)
            };
        },

        /**
         *  Getting references to the DOM for notifications and change icon based on user state
         */
        setNotificationIcon() {
            this.navNotificationElement = document.querySelector('.js-notification-link');

            // MYNOT-679: Accessibility bit
            this.navNotificationElement.onkeydown = (e) => {
                const charCode = e.which || e.charCode;

                if (charCode === 13) {
                    this.lastEnterPress = Date.now();
                }
            };

            this.orb.refresh();
        },

        getNavNotificationEl() {
            return this.navNotificationElement;
        },

        /**
         * Wrap for ORB api to get drawer state
         * @returns {[[Type]]} [[Description]]
         */
        getDrawerState() {
            return this.orb.getDrawerState(this.drawerName);
        },

        /**
         * Reset the onboarding carousel when hub closes
         */
        resetOnboarding() {
            onboarding.resetOnboarding();
            onboarding.init(this.getOnboardingParams());
        },

        /**
         * Getter for the preferences model
         * @return {UserPreferences} user preferences model
         */
        getUserPreferencesModel() {
            return userPreferencesModel;
        },

        /**
         * Check if browser is IE and returns IE version
         * @returns {Number} Version of IE
         */
        isIE() {
            if (document.documentMode) {
                return document.documentMode;
            }

            for (let i = 7; i > 0; i--) {
                const div = document.createElement('div');

                div.innerHTML = `<!--[if IE ${i}]><span></span><![endif]-->`;

                if (div.getElementsByTagName('span').length) {
                    return i;
                }
            }

            return undefined;
        },

        /**
         * Removes all the style heights added previously. (For IE)
         */
        removeCustomHeights() {
            onboarding.removeCustomHeights();
        }
    };
}

module.exports = main;



/** WEBPACK FOOTER **
 ** ./assets/js/NotificationsMain.js
 **/